import { Component, OnInit, Input } from '@angular/core';
import * as leafMap from 'leaflet';

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.sass']
})

export class MapComponent implements OnInit {
  @Input() lat: Number;
  @Input() long: Number;

  private map = 'empty';

  private initMap(): void {
      this.map = leafMap.map('map', {
        center: [   this.lat, this.long ],
        zoom: 17
      });
    
      var greenIcon = leafMap.icon({
        iconUrl: '../../assets/img/ExcessMaterialArea.png',
        shadowUrl: '',
    
        iconSize:     [100, 100], // size of the icon
        shadowSize:   [50, 64], // size of the shadow
        iconAnchor:   [50, 50], // point of the icon which will correspond to marker's location
        shadowAnchor: [4, 62],  // the same for the shadow
        popupAnchor:  [0, 0] // point from which the popup should open relative to the iconAnchor
    });
        // show the scale bar on the lower left corner
        leafMap.control.scale().addTo(this.map);
        leafMap.marker([ this.lat, this.long ], {icon: greenIcon}).addTo(this.map);
  

    const tiles = leafMap.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 40,
      minZoom: 3,
      attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
    });

    tiles.addTo(this.map);
  }

  constructor() { }

  ngOnInit() {
    if (this.map === 'empty') {
      this.initMap();

    }
  }
}

// https://geocode.search.hereapi.com/v1/geocode?q=2884 S. Yates St&apikey=nwdhuDy2A3e4rgFqVqY-gMxdVBxtmLZUHTABM8_mpWI